<template>
  <div class="page-body">
    <b-card class="content-card">
      <div fluid>
        <div class="appbar-container">
          <h3 class="appbar-container__title">لیست جایره ها</h3>
          <b-button
            to="/reward-center/rewards/create"
            size="md"
            variant="success"
            class="mr-1"
          >
            ایجاد جایزه
          </b-button>
        </div>
        <div class="filters-container">
          <h4 class="title">فیلتر بر اساس :</h4>
          <div class="filters">
            <div class="text-right">
              <b-form-select
                v-model="filters.active"
                :options="statusItems"
              ></b-form-select>
            </div>

            <div class="text-right mr-3">
              <b-form-select
                v-model="filters.campaign"
                :options="campaignItems"
              ></b-form-select>
            </div>
          </div>
          <div class="actions text-right">
            <b-button
              @click="resetFilters"
              size="md"
              variant="secondary"
              class="ml-2"
            >
              ریست
            </b-button>

            <b-button
              @click="fetchData()"
              size="md"
              variant="primary"
              class="mr-1"
            >
              جستجو
            </b-button>
          </div>
        </div>
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-table
          class="reward-table"
          v-else
          :items="items"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(image)="row">
            <div class="text-center">
              <img
                :src="row.item.image"
                alt=""
                style="max-width: 80px; max-height: 80px"
              />
            </div>
          </template>

          <template #cell(name)="row">
            <div class="text-center">
              {{ row.item.name }}
            </div>
          </template>

          <template #cell(status)="row">
            <div class="text-center">
              <div :class="['reward-status-chip', row.item.status.type]">
                {{ row.item.status.label }}
              </div>
            </div>
          </template>

          <template #cell(campaign)="row">
            <div class="text-center">
              <badge :type="row.item.campaign.status ? 'success' : 'danger'">
                <b-icon
                  v-if="row.item.campaign.status"
                  icon="check"
                  font-scale="2"
                ></b-icon>

                <b-icon v-else icon="x-circle" font-scale="2"></b-icon>
              </badge>
              <div v-if="row.item.campaign.date">
                <badge class="mt-2">
                  <span dir="ltr">
                    {{ row.item.campaign.date_from }}
                  </span>
                  <span class="d-inline-flex mx-1"> تا </span>
                  <span dir="ltr">
                    {{ row.item.campaign.date_to }}
                  </span>
                </badge>
              </div>
            </div>
          </template>

          <template #cell(actions)="row">
            <b-button
              size="sm"
              :to="`/reward-center/rewards/details/${row.item.id}`"
              variant="primary"
              class="mr-1"
            >
              نمایش جزییات جایزه
            </b-button>

            <b-button
              @click="showModalUpdateReward(row.item.id, !row.item.active)"
              size="sm"
              variant="warning"
              class="mr-1"
            >
              تغییر وضعیت جایزه
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-row no-gutters>
      <b-col sm="12" class="my-1 d-flex justify-content-center">
        <BasePagination
          :showNext="showNext"
          :showPrev="filters.page_number !== 0"
          @onClick="handlePaginationClick"
        />
      </b-col>
    </b-row>
    <b-modal
      hide-footer
      class="text-right"
      title="تغییر وضعیت جایزه"
      id="update-reward"
    >
      <h3 class="my-4">آیا مطمئن هستید ؟</h3>
      <div class="d-flex align-items-center justify-content-between">
        <b-button
          class="mt-3"
          variant="outline-danger"
          @click="$bvModal.hide('update-reward')"
        >
          بستن
        </b-button>
        <base-button
          :loading="updateRewardData.loading"
          class="mt-2"
          type="success"
          @click="updateReward"
        >
          تایید
        </base-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { fetchAll, updateReward } from "@/httpservices/Reward";
import BasePagination from "@/components/BasePagination.vue";
import moment from "jalali-moment";

export default {
  name: "RewardList",

  data() {
    return {
      loading: true,
      filters: {
        active: null,
        campaign: null,
        page_size: 10,
        page_number: 0,
      },
      statusItems: [
        {
          value: null,
          text: "انتخاب وضعیت جایزه",
          selected: true,
        },
        {
          value: true,
          text: "فعال",
        },
        {
          value: false,
          text: "غیر فعال",
        },
      ],
      campaignItems: [
        {
          value: null,
          text: "انتخاب وضعیت کمپین",
          selected: true,
        },
        {
          value: true,
          text: "دارای کمپین",
        },
        {
          value: false,
          text: "بدون کمپین",
        },
      ],
      items: [],
      fields: [
        {
          key: "image",
          label: "تصویر",
          sortable: false,
          class: "text-center",
        },
        {
          key: "name",
          label: "نام",
          sortable: false,
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: false,
          class: "text-center",
        },
        {
          key: "campaign",
          label: "کمپین",
          sortable: false,
          class: "text-center",
        },
        { key: "actions", class: "text-center", label: "عملیات" },
      ],
      updateRewardData: {
        reward_id: null,
        active: null,
        loading: false,
      },
    };
  },

  mounted() {
    this.$nextTick(async () => {
      await this.fetchData();
    });
  },

  components: {
    BasePagination,
  },

  computed: {
    showNext() {
      if (this.filters.page_number === 0) {
        if (this.items.length < this.filters.perPage) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.items.length < this.filters.perPage ||
          this.items.length === 0
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  methods: {
    handlePaginationClick(value) {
      if (value === -1) {
        if (this.filters.page_number > 0) {
          this.filters.page_number--;
          this.fetchData();
        }
      } else if (value === 1) {
        this.filters.page_number++;
        this.fetchData();
      }
    },

    async fetchData() {
      const getImage = (item) => {
        if (item.reward_image_url) {
          return (
            process.env.VUE_APP_REWARD_CENTER_BASE_URL + item.reward_image_url
          );
        }
        return "/img/placeholder-image.jpg";
      };

      this.loading = true;
      fetchAll(this.filters)
        .then((res) => {
          this.loading = false;
          this.items = res.data.data.map((item) => {
            return {
              ...item,
              image: getImage(item),
              status: {
                label: item.active ? "فعال" : "غیر فعال",
                type: item.active ? "active" : "inactive",
              },
              campaign: {
                status: item.campaign,
                date: Boolean(item.date_from && item.date_to),
                date_from:
                  item.date_from &&
                  moment(item.date_from).locale("fa").format("jYYYY jDD jMMMM"),
                date_to:
                  item.date_to &&
                  moment(item.date_to).locale("fa").format("jYYYY jDD jMMMM"),
              },
            };
          });
        })
        .catch((e) => {
          console.log({ e });
        });
    },

    resetFilters() {
      this.filters = {
        ...this.filters,
        active: null,
        campaign: null,
        page_size: 10,
        page_number: 0,
      };
      this.fetchData();
    },

    showModalUpdateReward(id, active) {
      this.updateRewardData = {
        modal: true,
        reward_id: id,
        active,
      };
      this.$bvModal.show("update-reward");
    },

    updateReward() {
      this.updateRewardData.loading = true;
      updateReward({
        ...this.updateRewardData,
        active: this.updateRewardData.active ? "true" : "false",
      })
        .then((res) => {
          this.updateRewardData.loading = false;
          this.$bvModal.hide("update-reward");
          const updatedRewardIndex = this.items.findIndex(
            (i) => i.id === this.updateRewardData.reward_id
          );
          this.items = this.items.map((item, index) => {
            const status = {
              label: this.updateRewardData.active ? "فعال" : "غیر فعال",
              type: this.updateRewardData.active ? "active" : "inactive",
            };
            return {
              ...item,
              active:
                index === updatedRewardIndex
                  ? this.updateRewardData.active
                  : item.active,
              status: index === updatedRewardIndex ? status : item.status,
            };
          });
        })
        .catch((e) => {
          console.log(e);
          this.updateRewardData.loading = false;
        });
    },
  },

  watch: {
    "filters.active"() {
      this.filters.page_number = 0;
    },
    "filters.campaign"() {
      this.filters.page_number = 0;
    },
  },
};
</script>

<style lang="scss">
.modal-header .close {
  padding: 0;
  margin: 0;
}

.modal-body {
  text-align: right;
}

.reward-table td {
  height: 60px;
}

.reward-table td > div {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.appbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__title {
    font-size: 24px;
  }
}

.reward-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: #ccc;
  padding: 5px;
  width: 100px;
  margin: auto;
}

.reward-status-chip.active {
  color: white;
  background-color: #2dce89;
}

.reward-status-chip.inactive {
  color: white;
  background-color: #f45656;
}

.filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 15px;
  background-color: #eee;
  border-radius: 5px;

  .title {
    display: flex;
    min-width: 150px;
  }

  .filters {
    width: 100%;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .actions {
    display: flex;
  }
}
</style>
